module.exports = __webpack_public_path__ + "static/media/plan_selected.3bd39a0f.svg";